import angular from 'angular';

export default angular
  .module('est.theme', ['ngMaterial', 'ngAnimate'])
  .config(config);

config.$inject = ['$mdThemingProvider', '$animateProvider'];

function config(
  $mdThemingProvider: angular.material.IThemingProvider,
  $animateProvider: angular.animate.IAnimateProvider,
) {
  // Extend the orange theme with a few different colors
  const estOfficeMap = $mdThemingProvider.extendPalette('orange', {
    //'500': 'ff0000'
  });

  $mdThemingProvider.definePalette('estOfficeOrange', estOfficeMap);

  $mdThemingProvider
    .theme('default')
    .primaryPalette('estOfficeOrange')
    .accentPalette('orange');

  $animateProvider.classNameFilter(/\banimate-/);
}
